export const LIBRARY_ROUTE_PREFIX = 'your-library'

export const LIBRARY_ROUTES = {
    landing: 'your-library',
    mixes: 'your-library/mixes',
    artists: 'your-library/artists',
    genres: 'your-library/genres',
    shows: 'your-library/shows',
    search: 'your-library/search',
}
